import { render, staticRenderFns } from "./Bankruptcy.vue?vue&type=template&id=032a5923"
import script from "./Bankruptcy.vue?vue&type=script&lang=js"
export * from "./Bankruptcy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports